import { Link } from "react-router-dom";

const Banner = (props) => {
    return (
        <section
            className="page-title"
            style={{
                backgroundImage: `url(${props.img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            {/* Content */}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 text-center">
                        <Link to="/">
                            <span className="text-white d-block banner-title">{props.title}</span>
                        </Link>
                        <h1 className="text-white text-capitalize mb-4 banner-desc">
                            {props.desc}
                        </h1>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
